module.exports = __webpack_public_path__ + "static/img/4.d708ffd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/eng/4.png
// module id = KiZb
// module chunks = 0